'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProgressBar = require('./components/ProgressBar.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ProgressBar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-progress-bar/lib/index.js
// module id = 94
// module chunks = 1